import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode } from "react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3_000,
      refetchOnWindowFocus: false,
      // Retry transient network errors up to 2 times (500ms, 1.5s backoff).
      // Auth (401) and client 4xx are NOT retried — api-client redirects 401
      // to /login and 4xx usually means a stable "not found" / validation
      // error that won't resolve by retrying.
      retry: (failureCount, error) => {
        if (failureCount >= 2) return false;
        const msg = (error as Error)?.message ?? "";
        if (/^(Unauthorized|Bad Request|Forbidden|Not Found)$/i.test(msg)) return false;
        // Retry CF tunnel origin-unreachable / CF Pages default 404 HTML
        // errors, and anything ambiguous that might be transient.
        return true;
      },
      retryDelay: attempt => Math.min(500 * 2 ** attempt, 3_000),
    },
  },
});

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
